export default "__VITE_ASSET__CWBW$XOP__"